import { useNavigate } from 'react-router-dom';

import { Typography } from 'antd';

import BaseCard from '@/components/shared/BaseCard';
import Shelf from '@/components/shared/Shelf';
import { getCdnUrl } from '@/helpers';
import { useGetKeepWatchingShelfQuery } from '@/services/resume';
import styled, { StyledProp } from '@/styled';

const KeepLearningShelf = ({ ...rest }: StyledProp) => {
  const navigate = useNavigate();
  const { data, isFetching } = useGetKeepWatchingShelfQuery('');

  if (!data?.length && !isFetching) {
    return null;
  }

  return (
    <Shelf
      title={
        <Typography.Title level={4} ellipsis id='keepLearning-shelf'>
          Continue aprendendo
        </Typography.Title>
      }
      shelfProps={{
        isFetching
      }}
      carouselProps={{ slidesToShow: 4 }}
      {...rest}
    >
      <>
        {data?.map(course => (
          <swiper-slide key={course.id}>
            <BaseCard
              onClick={() => navigate(`/curso/${course.hash}/aula/${course.lesson_id}`)}
              image={{
                src: getCdnUrl(course.course_newcard_background, course.image, course.old_image),
                aspect: '16:9',
                alt: course.title
              }}
              internalSpace={16}
              id={`keep-learning-course-card-${course.hash}`}
            >
              <Typography.Paragraph ellipsis>{course.title}</Typography.Paragraph>
            </BaseCard>
          </swiper-slide>
        ))}
      </>
    </Shelf>
  );
};

export default styled(KeepLearningShelf)`
  .base-card-data {
    .ant-typography {
      margin-bottom: 0;
      color: ${({ theme }) => theme.colorTextSecondary};
    }
  }
`;
